import { Subject } from "rxjs";
export enum GlobalMessageType {
  TRADE_CHANGE = "TRADE_CHANGE",
  GET_MAKRS = "GET_MARKS",
  WALLET_ADDRESS_CHANGE = "WALLET_ADDRESS_CHANGE",
  KLINE_PARAMS = "KLINE_PARAMS",
  KLINE_DATA = "KLINE_DATA",
  KLINE_PRICE_FIRST = "KLINE_PRICE_FIRST",
  WATCH_WALLET_TRADE_CHANGE = "WATCH_WALLET_TRADE_CHANGE",
  GET_TOKEN_INFO = "GET_TOKEN_INFO",
}

export enum PostMessageType {
  GET_KLINE_DATA = "GET_KLINE_DATA",
  KLINE_READY = "KLINE_READY",
  PERIOD_CLICK = "PERIOD_CLICK",
}

export const GloablMessageSub = new Subject<{
  type: GlobalMessageType;
  data?: any;
}>();
